import { schema } from 'normalizr';
import ApplicationVariableConfigurationSchema from './ApplicationVariableConfigurationSchema';

const ApplicationDetailsCardSchema = new schema.Entity('applicationDetailsCards', {
  fields: [ApplicationVariableConfigurationSchema],
});

export default ApplicationDetailsCardSchema;
